module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "invite-url-box text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.invitation_url))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.invitation_url),
      expression: "invitation_url",
      arg: "copy"
    }],
    staticClass: "copy",
    attrs: {
      "title": _vm.$t('clickCopy')
    },
    on: {
      "click": _vm.copyComplete
    }
  }, [_vm._v(_vm._s(_vm.$t('copy')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "copy"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.copied),
      expression: "copied"
    }],
    staticClass: "copy-complete"
  }, [_vm._v(_vm._s(_vm.$t('copySuccess')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ec6ae85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inviteUrl/Index.vue
// module id = 1294
// module chunks = 1